// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { get } from 'lodash'
import AnimateHeight from 'react-animate-height'
import Select from 'react-select'
import { FormFieldLayout } from '../../generic'

export default function MultiSelectField({
  errors,
  formatOptionLabel,
  formKey,
  onChange,
  customOnChange,
  customValues,
  style,
  options,
  placeholder,
  values,
  ...props
}) {
  let optionKey
  if (options && options[0]) {
    optionKey = options[0].id ? 'id' : 'value'
  }
  const formValues = get(values, formKey) || []
  const error = get(errors, formKey)

  return (
    <FormFieldLayout hasErrors={!!error} {...props}>
      <Select
        classNamePrefix={error ? 'lmc-select-error' : 'lmc-select'}
        closeMenuOnSelect={false}
        formatOptionLabel={formatOptionLabel}
        getOptionLabel={(option) => option.name || option.label}
        getOptionValue={(option) => option[optionKey]}
        isMulti
        menuPlacement="auto"
        onChange={(selected) =>
          customOnChange
            ? customOnChange?.(selected)
            : onChange({
                key: formKey,
                value: selected.map((option) => option[optionKey])
              })
        }
        options={options}
        placeholder={placeholder}
        value={
          customOnChange
            ? customValues
            : options.filter((option) => formValues.includes(option[optionKey]))
        }
      />
      <AnimateHeight animateOpacity duration={200} height={error ? 'auto' : 0}>
        <div style={styles.error}>{error}</div>
      </AnimateHeight>
    </FormFieldLayout>
  )
}

const styles = {
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 5
  }
}
